/* Types */
import type { Yandex } from '@/store/analytics/analytics.types'

import type { MetricsConstructor } from '@/services/metrics/types/service.types'
import type { MetricsNames } from '@/services/metrics/types/service.types'

/**
 * Формирование объекта конфигурации для метрики
 * @param name - наименование метрики
 * @param ids - идентификаторы метрики
 * @param ecommerce - toggle включения ecommerce
 * @param exception - обработчик ошибки
 */
export const getConfigOfMetric = (
  name: MetricsNames,
  ids: Yandex,
  ecommerce: boolean,
  exception: any,
): MetricsConstructor => {
  return {
    name,
    ids: {
      mainId: ids.main_id,
      cityId: ids.city_id,
    },
    ecommerce,
    exceptionError: exception,
  }
}
